/* eslint-disable import/prefer-default-export */
import breadcrumbSchema from '../schemas/breadcrumb';

export const generateBreadcrumbs = ({ scholarshipURL }) => {
  const breads = [
    {
      name: 'Home',
      url: 'https://unacademy.com'
    },
    {
      name: 'Scholarship',
      url: scholarshipURL
    }
  ];

  return breadcrumbSchema(breads);
};
